const FASTAPI_URL = process.env.REACT_APP_FASTAPI_URL || "http://localhost:8000";

function getJWT() {
  return window.localStorage.getItem("faqhelps_jwt");
}

/**
 * Call FastAPI’s /search endpoint (protected by JWT).
 * @param {object} options
 * @param {number} options.companyId   – your tenant/company ID
 * @param {string} options.queryText   – the user’s search string
 * @param {number|null} options.userId – optional user ID for custom FAQs
 */
export async function fetchFaqMatches({ companyId, queryText, userId = null }) {
  if (!companyId || !queryText) {
    throw new Error("companyId and queryText are required");
  }

  const token = getJWT();
  if (!token) {
    throw new Error("No JWT—user must log in first");
  }

  const response = await fetch(`${FASTAPI_URL}/search`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({
      query:      queryText.trim()
    }),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`FastAPI /search error ${response.status}: ${text}`);
  }

  const data = await response.json();
  return data.matches || [];
}
